import {
  Favorite,
  FavoriteParams,
  FavoriteRequestData,
} from 'shared/api/avia/favorites/model.ts'
import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'
import { TicketItem } from 'shared/models/ticket.ts'

export const FavoritesApi = {
  getFavorites() {
    return clientApi.get<Response<Favorite[]>>(`/flights/favorites`)
  },

  getFavoriteDetail(
    key: string,
    searchParams: FavoriteParams,
    abort?: AbortSignal,
  ) {
    return clientApi.get<Response<TicketItem>>(`/flights/favorites/${key}`, {
      params: {
        ...searchParams,
      },
      signal: abort,
    })
  },

  createFavorite(data: FavoriteRequestData) {
    return clientApi.post('/flights/favorites', data)
  },

  removeFavorite(key: string, searchParams: FavoriteParams) {
    return clientApi.delete<Response<Favorite>>(`/flights/favorites/${key}`, {
      params: {
        ...searchParams,
      },
    })
  },

  removeAllFavorites() {
    return clientApi.delete<Response<Favorite>>(`/flights/favorites`)
  },
}
